import { useEffect, useState } from 'react';
import {
  ToggleInput,
  ButtonSecondary,
  ButtonSize,
  PermissionEnum,
} from '@ui/src';
import { useAppSelector } from '@store';
import {
  CustomerStatus,
  CustomerType,
  TopUpVisibility,
} from '../../../hoc/customers/types';
import {
  useAddTopUpVisibilityMutation,
  useUpdateTopUpVisibilityMutation,
} from '../../../hoc/customers/store/services/customers';
import { TopUpOptionItemTypes } from './types';

import cn from './overview-topup.module.css';

const TopUpOptionItem = ({
  topUpOption,
  setTopUpPanelIsOpen,
  organizationId,
  customerType,
  setSelectedTopUpId,
  status,
  visibility: visibilityItem,
  topUpVisibilityIsLoading,
}: TopUpOptionItemTypes) => {
  const [hover, setHover] = useState(false);
  const [checked, setChecked] = useState(false);
  const [visibility, setVisiblity] = useState<TopUpVisibility>();

  const { activePermissions } = useAppSelector(
    (state) => state.customersDictionaries,
  );

  const [addVisibility] = useAddTopUpVisibilityMutation();
  const [updateVisibility] = useUpdateTopUpVisibilityMutation();

  const addVisibilityAction = async (visible: boolean) => {
    const response = (await addVisibility({
      id: topUpOption?.id as string,
      body: {
        organizationId: organizationId as string,
        visible,
      },
    })) as {
      data: {
        data: TopUpVisibility;
      };
    };

    if (response?.data.data) {
      setVisiblity(response.data.data);
    }
  };

  const updateVisibiliyAction = async (visible: boolean) => {
    const response = (await updateVisibility({
      id: visibility?.id as string,
      pspId: topUpOption?.id as string,
      body: {
        pspPartnerId: visibility?.pspPartnerId as string,
        organizationId: organizationId as string,
        visible,
      },
    })) as {
      data: {
        data: TopUpVisibility;
      };
    };

    if (response?.data.data) {
      setVisiblity(response.data.data);
    }
  };

  useEffect(() => {
    if (topUpOption && !topUpVisibilityIsLoading) {
      if (visibilityItem) {
        setVisiblity(visibilityItem);
        setChecked(visibilityItem.visible);
      } else {
        setChecked(topUpOption?.visibleToClients);
      }
    }
  }, [visibilityItem, topUpOption, topUpVisibilityIsLoading]);

  return (
    <div
      className={cn.topUpOptionItem}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div className={cn.topUpOptionItemBlock}>
        <div className={cn.topUpOptionItemBlockContent}>
          <ToggleInput
            name={`toggle-${topUpOption?.id}`}
            title=""
            disabled={
              !activePermissions?.includes(
                customerType === CustomerType.INDIVIDUAL
                  ? PermissionEnum.INDIVIDUAL_CUSTOMERS_EDIT_TOPUP_ACTION
                  : PermissionEnum.CORPORATE_CUSTOMERS_EDIT_TOPUP_ACTION,
              ) || status === CustomerStatus.CLOSED
            }
            checked={checked}
            onChange={(e) => {
              setChecked(e.target.checked);

              if (!visibility) {
                addVisibilityAction(e.target.checked);
              } else {
                updateVisibiliyAction(e.target.checked);
              }
            }}
          />
          <div className={cn.topUpOptionValue}>{topUpOption?.companyName}</div>
        </div>
      </div>
      <div className={cn.topUpOptionItemBlock}>
        <div className={`${cn.topUpOptionItemBlockContent}  ${cn.topUpEnd}`}>
          {hover && (
            <ButtonSecondary
              className={`button-white ${cn.downloadButton}`}
              text=" Top-up Instruction"
              size={ButtonSize.SMALL}
              onClick={() => {
                setTopUpPanelIsOpen(true);
                setSelectedTopUpId(topUpOption?.id as string);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TopUpOptionItem;
